import { KeyMetricsType } from '../../constants';
import { SymbolType } from '@op/constants/chart';

export const TOP_METRICS: KeyMetricsType[] = [
  'impressions',
  'views',
  'engagement',
  'engagement_rate',
];

export const TOP_CHART_TYPES: SymbolType[] = ['line', 'stack_line', 'bar'];

export const METRIC_SORT_LABEL: Record<string, string> = {
  impressions: 'Followers',
  views: 'Views',
  engagement: 'Engagement',
  engagement_rate: 'Engagement Rate',
};

/** Chart metric key → feeds detail sort_item */
export const METRIC_SORT_ITEM: Record<string, string> = {
  impressions: 'follower_number',
  views: 'view',
  engagement: 'engagement',
};

export function getMetricSortItem(metric: string): string | undefined {
  return METRIC_SORT_ITEM[metric];
}

export function isTopMetric(metric: KeyMetricsType): boolean {
  return TOP_METRICS.includes(metric);
}

export function isTopChartType(chartType: SymbolType): boolean {
  return TOP_CHART_TYPES.includes(chartType);
}

const TIMELINE_ONLY_KEYS = ['metrics', 'by_type', 'games', 'dataType'] as const;

export function buildCommunityTimelineTopPayload(
  baseFilter: Record<string, any>,
  options: {
    tab_type: string;
    metric: string;
    clickParams: Record<string, any>;
    otherParams?: Record<string, any>;
    limit?: number;
  },
): Record<string, any> {
  const cleaned = { ...baseFilter };
  TIMELINE_ONLY_KEYS.forEach(key => {
    delete cleaned[key];
  });

  return {
    ...cleaned,
    ...(options.otherParams || {}),
    tab_type: options.tab_type,
    metric: options.metric,
    limit: options.limit ?? 3,
    ...options.clickParams,
  };
}
